export default __webpack_public_path__ + "locales/fr/Files.json?hash=b7040ac9acabe55e627e88162703a9c0";